import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminMileagesApi, useMyCarMileagesApi } from "../../http/mileages/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteMileageDialogProps = {
  mileageId: string;
  carId?: string;
  onClose: (success?: boolean) => void;
  carDriverId?: string;
};

const DeleteMileageDialog: FC<DeleteMileageDialogProps> = ({ mileageId, carId, onClose, carDriverId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const mileagesAdminApi = useAdminMileagesApi();
  const mileagesApi = useMyCarMileagesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onClick = () => {
    setIsSubmitting(true);
    try {
      if (!!carDriverId) {
        mileagesApi.deleteMileage(mileageId, carId!, carDriverId);
      } else {
        mileagesAdminApi.deleteMileage(mileageId, carId);
      }
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.mileages.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: onClick,
        },
      ]}
    >
      {i18n.t.mileages.questions.delete}
    </ModalDialog>
  );
};

export default DeleteMileageDialog;
